/**
 * Balance Trends Hook
 *
 * React Query hook for fetching account balance trend data.
 * Powers sparkline charts on account rows.
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { balanceTrendService } from '../services/balance-trend-service';

export const balanceTrendKeys = {
  all: ['balance-trends'] as const,
  list: (accountIds: string[], household?: boolean, userId?: string, days?: number) =>
    [...balanceTrendKeys.all, 'list', { accountIds, household, userId, days }] as const,
};

export function useBalanceTrends(accountIds: string[], household?: boolean, userId?: string, days: number = 30) {
  return useQuery({
    queryKey: balanceTrendKeys.list(accountIds, household, userId, days),
    queryFn: () =>
      balanceTrendService.getTrends({
        account_ids: accountIds,
        days,
        household,
        user_id: userId,
      }),
    enabled: accountIds.length > 0,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
